import { onLoad } from "@/utils/_"

const plugin: NuxtPlugin = ({ isDev }) => {
  if (isDev) return
  const id = "3658697"
  if (!id) return

  onLoad(() => {
    const script = document.createElement("script")
    script.text = `
      window._tmr = window._tmr || []
      window._tmr.push({
        id: "${id}",
        type: "pageView",
        start: new Date().getTime(),
      })
      if (!document.getElementById("tmr-code")) {
        const ts = document.createElement("script")
        ts.type = "text/javascript"
        ts.async = true
        ts.id = "tmr-code"
        ts.src = "https://top-fwz1.mail.ru/js/code.js"
        const insert = () => {
          const s = document.getElementsByTagName("script")[0]
          s.parentNode.insertBefore(ts, s)
        }
        if (window.opera === "[object Opera]") document.addEventListener("DOMContentLoaded", insert, false)
      else insert()
    }
    `
    document.body.appendChild(script)
  })
}

export default plugin
